import { SHOPPING_LISTS_ENDPOINTS } from "./endpoints";
import type { ItemAction, UpdateItemOptions, UpdateItemResponse } from "./types";
import { apiRequestWithData, apiPatch } from "../shared";

function buildRequestBody(
  action: ItemAction,
  options?: UpdateItemOptions
): Record<string, string | number | number[] | undefined> {
  const body: Record<string, string | number | number[] | undefined> = { action };
  if (action === "update" && options) {
    if (options.quantity !== undefined) body.quantity = options.quantity;
    if (options.unit !== undefined) body.unit = options.unit;
    if (options.ingredientId !== undefined) body.ingredientId = options.ingredientId;
    if (options.genericIngredientId !== undefined) body.genericIngredientId = options.genericIngredientId;
    if (options.name !== undefined) body.name = options.name;
    if (options.alternativeIngredientIds !== undefined)
      body.alternativeIngredientIds = options.alternativeIngredientIds;
    if (options.alternativeGenericIngredientIds !== undefined)
      body.alternativeGenericIngredientIds = options.alternativeGenericIngredientIds;
  }
  return body;
}

export async function updateShoppingListItem(
  listId: string,
  itemId: string,
  action: ItemAction,
  options?: UpdateItemOptions
): Promise<UpdateItemResponse> {
  const url = SHOPPING_LISTS_ENDPOINTS.UPDATE_ITEM(listId, itemId);

  if (action === "delete") {
    await apiPatch(url, { action });
    return { message: "Item deleted successfully" };
  }

  const body = buildRequestBody(action, options);
  return apiRequestWithData<UpdateItemResponse>(url, {
    method: "PATCH",
    body: JSON.stringify(body),
  });
}

export default updateShoppingListItem;
